<template>
  <div
    v-if="props.loading || props.value"
    class="rounded bg-stone-50 p-3 text-lg flex flex-col border-stone-100 border-3 group"
    :class="{ 'cursor-pointer': !props.loading && props.copyOnClick }"
    @click="copy"
  >
    <div font-mono text-stone-500 lh-snug pb-2>
      <slot name="label">
        {{ props.label }}
      </slot>
    </div>
    <div text-3xl font-semibold text-stone-700 tabular-nums :class="props.valueClass">
      <slot>
        <span v-html="displayValue"></span>
        <div
          :invisible="!loading && displayValue"
          class="text-[0.75em]"
          sm:invisible
          inline-block
          group-hover:visible
          group-active:opacity-50
          i-material-symbols-content-copy-outline-rounded
          text-stone-400
          pl-2
          ml-1
          animate-count-1
          :class="{ 'animate-ping': copied, 'group-hover:visible': !props.loading && props.copyOnClick }"
        />
      </slot>
      <!-- visually flash the copy symbol on copy to indicate action on mobile -->
    </div>
  </div>
</template>
<script setup>
const props = defineProps({
  label: String,
  value: String,
  units: String,
  valueClass: String,
  loading: Boolean,
  copyOnClick: {
    type: Boolean,
    default: true,
  },
});
const displayValue = computed(() => {
  if (props.loading && !props.value) {
    return " ";
  }
  if (props.units) {
    return `${props.value} ${props.units}`;
  }
  return props.value;
});

const copied = ref(false);

async function copy() {
  if (props.loading || !props.copyOnClick) {
    return;
  }
  try {
    await navigator.clipboard.writeText(displayValue.value);
    copied.value = true;
    setTimeout(() => {
      copied.value = false;
    }, 1000);
  } catch (err) {
    console.error("Failed to copy: ", err);
  }
}
</script>
